<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <confirm-modal
      v-bind:bodyText="textConfirmDeleteModal"
      v-bind:show="confirmDeleteModal"
      @confirm="onDelete()"
      @hidden="
        confirmDeleteModal = false;
        textConfirmDeleteModal = '';
        deleteUserId = 0;
      "
    >
    </confirm-modal>
    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Group</h4>
            <b-tabs
              v-if="groups && groups.length"
              pills
              vertical
              nav-class="p-0"
              nav-wrapper-class="col-sm-3"
              content-class="col-sm-9 pt-0 px-2 text-muted"
            >
              <template v-for="(item, index) in groups">
                <b-tab
                  :key="index"
                  :active="index === 0"
                  title-item-class="mb-2"
                  @click="setGroupSelected(item.id)"
                >
                  <template #title>
                    <div>
                      <i class="bx bx-right-arrow-circle"></i>
                      {{ index + 1 }}) {{ item.display_name }}
                    </div>
                  </template>
                  <b-card-text>
                    <div class="row mb-2">
                      <div class="col-sm-8">
                        <h4 class="card-title mb-4" v-if="group">
                          Users of {{ group.display_name }}
                        </h4>
                      </div>
                      <div class="col-sm-4">
                        <div class="text-sm-right">
                          <button
                            @click="toggleSideBar = !toggleSideBar"
                            type="button"
                            class="btn btn-success waves-effect waves-light"
                          >
                            <i class="fa fa-plus"></i>
                            Add user
                          </button>
                        </div>
                      </div>
                    </div>
                    <div class="card">
                      <div class="card-body">
                        <div class="row form-group">
                          <div class="col-sm-12 col-md-8"></div>
                          <div class="col-sm-12 col-md-4">
                            <div class="input-group md-form form-sm text-md-right">
                              <div class="input-group-prepend">
                                <span class="input-group-text">
                                  <span class="bx bx-search-alt"></span>
                                </span>
                              </div>
                              <input
                                v-model="search"
                                class="form-control my-0 py-1"
                                type="search"
                                placeholder="ค้นหา"
                                aria-label="Search"
                              />
                              <div class="button-items ml-1"></div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-md-12">
                            <div class="overflow-auto">
                              <b-table
                                class="table table-centered table-nowrap"
                                ref="grouptable"
                                :empty-text="'ไม่พบข้อมูล'"
                                :show-empty="!$validate.anyArrayObjectValid(groupUsers)"
                                :bordered="true"
                                :filter="search"
                                :items="groupUsers"
                                align="center"
                                v-bind:fields="groupUserFields"
                                :per-page="perPage"
                                :current-page="currentPage"
                              >
                                <template v-slot:cell(index)="data">
                                  <div class="text-right">
                                    {{ (firstRowOnPage + data.index) | number }}
                                  </div>
                                </template>
                                <template v-slot:cell(status)="data">
                                  <span
                                    class="label"
                                    :class="'label-' + data.value.toLowerCase()"
                                    v-html="data.value"
                                  ></span>
                                </template>
                                <template v-slot:cell(info)="data">
                                  <label
                                    class="col-form-label col-sm-5"
                                    v-if="
                                      data.value.first_name && data.value.first_name.th
                                    "
                                  >
                                    <span class="badge-lang">TH</span
                                    >{{ data.value.first_name.th }}
                                    {{ data.value.last_name.th }}
                                  </label>
                                  <br />
                                  <label
                                    class="col-form-label col-sm-5"
                                    v-if="
                                      data.value.first_name && data.value.first_name.en
                                    "
                                  >
                                    <span class="badge-lang">EN</span
                                    >{{ data.value.first_name.en }}
                                    {{ data.value.last_name.en }}
                                  </label>
                                </template>
                                <template v-slot:cell(attribute)="data">
                                  <i
                                    class="mdi mdi-plus-circle-outline font-size-18 cursor-pointer"
                                    @click="
                                      modelAttribute = data;
                                      showAttributeModal = true;
                                    "
                                  ></i>
                                  <template
                                    v-if="$validate.isObjectValid(data.item.attribute)"
                                    ><label class="col-form-label col-sm-12">
                                      <span
                                        class="badge badge-pill badge-soft-primary font-size-11 mr-03rem"
                                        v-for="(key, index) in Object.keys(
                                          data.item.attribute
                                        )"
                                        :key="index"
                                      >
                                        <b style="font-size: small">{{ key }}</b
                                        >:
                                        {{ data.item.attribute[key].join(", ") }}
                                      </span>
                                    </label>
                                  </template>
                                </template>
                                <template v-slot:cell(action)="data">
                                  <div class="text-center">
                                    <a
                                      @click="onConfirmDelete(data.item.id)"
                                      class="btn btn-ico text-danger"
                                      ><i class="bx bx-trash"></i
                                    ></a>
                                  </div>
                                </template>
                              </b-table>
                            </div>
                          </div>
                        </div>
                        <div class="row form-group">
                          <div class="col-sm-12 col-md-8"></div>
                          <div class="col-sm-12 col-md-4">
                            <b-pagination
                              aria-controls="table"
                              v-model="currentPage"
                              :total-rows="groupUsers.length"
                              :per-page="perPage"
                              class="pagination pagination-rounded justify-content-end mb-2"
                            ></b-pagination>
                          </div>
                        </div>
                      </div>
                    </div>
                  </b-card-text>
                </b-tab>
              </template>
            </b-tabs>
          </div>
        </div>
      </div>
    </div>
    <sideBar
      v-show="isShowSideBar"
      ref="sideBar"
      :toggleSideBar="toggleSideBar"
      :applicationId="GET_APPLICATION_SELECTED.id"
      :groupId="group.id"
      :groupUsers="groupUsers"
      @hidden="toggleSideBar = false"
      @getGroupUsersSelected="getGroupUsersSelected"
    ></sideBar>
    <b-modal
      v-model="showAttributeModal"
      v-if="$validate.isObjectValid(modelAttribute)"
      @show="onDropdownShown(modelAttribute.item.id)"
      @hide="onModalAttributeHide"
      hide-footer
      centered
    >
      <template v-slot:modal-title>
        <h4 class="modal-title">Attribute</h4>
      </template>
      <div class="row">
        <div class="col-md-12 text-right">
          Email: {{ modelAttribute.item.info.email }}
          <div class="dropdown-divider" />
        </div>
        <div class="col-md-5 bd-sl-1">
          <div v-if="isDefaultParameterOptions" id="dropdown-group-1">
            <div class="col-md-12 text-right text-sm">Default</div>
            <div>
              <template
                v-for="(value, key) in onDefaultParameterOptions(modelAttribute.item.id)"
              >
                <div :key="key">
                  <label>
                    {{ key }}
                  </label>
                  <b-form-checkbox
                    class=""
                    v-for="(item, subIndex) in value"
                    :key="`${item}-${subIndex}`"
                    :value="{
                      key: key,
                      value: item,
                    }"
                    v-model="selectAttributesOptions"
                    >{{ item }}</b-form-checkbox
                  >
                  <div class="dropdown-divider" />
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="col-md-7">
          <div class="col-md-12 text-right text-sm">Custom</div>
          <div id="dropdown-group-1">
            <form>
              <b-form-group
                label-cols="3"
                label-cols-lg="3"
                label-size="sm"
                label="Key"
                label-for="input-sm"
                style="margin-bottom: 0"
              >
                <b-form-input
                  id="dropdown-form-attribute"
                  v-model="newAttributeKeyOption"
                  size="sm"
                  placeholder="business_unit_name"
                ></b-form-input>
              </b-form-group>
              <b-form-group
                label-cols="3"
                label-cols-lg="3"
                label-size="sm"
                label="value"
                label-for="input-sm"
                style="margin-bottom: 0"
              >
                <b-form-input
                  id="dropdown-form-attribute"
                  v-model="newAttributeValueOption"
                  size="sm"
                  placeholder="OFM"
                ></b-form-input>
              </b-form-group>
              <label class="text-sm text-link" @click="onNewAttributeOption"
                >Create new</label
              >
            </form>
          </div>
        </div>
      </div>
      <div class="dropdown-divider" />
      <div class="row">
        <div class="col-md-12 text-center">
          <label
            class="text-link text-center width-attr-right-rem"
            @click="onApplyAttributes(modelAttribute.item.id)"
            >Apply</label
          >
        </div>
      </div>
    </b-modal>
  </Layout>
</template>

<script>
import { FormatQty } from "@/helpers/utils/format-qty.js";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { eventBus } from "@/main.js";
import ConfirmModalComponnent from "@/components/share/modal-confirm.vue";
import { applicationComputed } from "@/state/helpers";

import sideBar from "@/components/group-user/sideBar";

import groupService from "@/helpers/service/group-provider";
import serviceService from "@/helpers/service/service-provider";

export default {
  page: {
    title: "Create New Group",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    "confirm-modal": ConfirmModalComponnent,
    sideBar,
  },
  data() {
    return {
      filter: {
        name: "",
        status: ["Active"],
        pageNo: 1,
        pageSize: 50,
      },
      search: null,
      toggleSideBar: false,
      id: "",
      action: "new",
      title: "Create New",
      firstRowOnPage: 1,
      items: [
        {
          text: "Home",
          href: "/",
        },
        {
          text: "Group",
          href: "/Groups",
        },
        {
          text: "Create New",
          active: true,
        },
      ],
      groups: [],
      group: {},
      groupUsers: [],
      groupUserFields: [
        {
          key: "index",
          formatter: (value, key, item) => {
            return FormatQty(value ? value : 0);
          },
          label: "ลำดับ",
          thStyle: "width:80px",
          sortable: false,
        },
        {
          key: "reference_id.crc_id",
          label: "Employee Id (CRC Id)",
          sortable: true,
        },
        {
          key: "info.email",
          label: "Email",
          sortable: true,
        },
        {
          key: "info",
          label: "Name",
          sortable: true,
        },

        {
          key: "attribute",
          label: "Attributes",
          sortable: false,
          thStyle: "width:80px",
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:80px",
        },
      ],
      confirmDeleteModal: false,
      textConfirmDeleteModal: "",
      deleteUserId: "",
      currentPage: 1,
      perPage: 10,
      defaultParameterOptions: {},
      tempDefaultParameterOptions: {},
      newAttributeKeyOption: "",
      newAttributeValueOption: "",
      selectAttributeOptions: {},
      selectAttributesOptions: [],
      applySelectAttributeOptions: {},
      showAttributeModal: false,
      modelAttribute: {},
      isDefaultParameterOptions: false,
    };
  },
  computed: {
    ...applicationComputed,
    isShowSideBar() {
      return (
        this.$validate.isValid(this.GET_APPLICATION_SELECTED.id) &&
        this.$validate.isObjectKeyValid(this.group, 'id')
      );
    },
    activeDefaultParameterOptions() {
      return this.isDefaultParameterOptions ? this.defaultParameterOptions : [];
    },
  },
  watch: {
    defaultParameterOptions: {
      handler(newVal) {
        // React to changes in the deep sub-model
        this.isDefaultParameterOptions = this.$validate.isObjectValid(
          this.defaultParameterOptions
        );
      },
      deep: true, // Enable deep watching
    },
  },
  mounted() {
    this.onDefaultAttributes();
    this.getGroups();
  },
  methods: {
    async getGroups() {
      let params = new URLSearchParams();
      params.append("pageSize", this.filter.pageSize);
      params.append("name", this.filter.name.trim() || "");
      this.filter.status.forEach((element) => {
        params.append("status", element);
      });

      let result = await groupService.getGroupsAsync(
        this.GET_APPLICATION_SELECTED.id,
        params
      );
      if (result.status === 200) {
        if (result.data.totalRecords > 0) {
          this.groups = result.data.items;
          this.group = this.groups[0];
          await this.getGroupUsersSelected(this.group.id);
        }
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    async setGroupSelected(groupId) {
      let groupSelected = this.groups.filter((q) => q.id === groupId);
      if (groupSelected.length > 0) {
        this.group = groupSelected[0];
        // console.log(this.group);
        await this.getGroupUsersSelected(this.group.id);
      }
    },
    async getGroupUsersSelected(groupId) {
      this.selectAttributeOptions = {};
      let result = await groupService.getGroupAsync(
        this.GET_APPLICATION_SELECTED.id,
        groupId
      );
      if (result.status === 200) {
        this.groupUsers = [];
        if (result.data && this.$validate.anyArrayObjectValid(result.data.users)) {
          this.groupUsers = result.data.users;
          this.groupUsers.forEach((element) => {
            this.selectAttributeOptions[element.id] = {};
            if (this.$validate.isObjectValid(element.attribute)) {
              for (const key in element.attribute) {
                this.selectAttributeOptions[element.id][key] =
                  element.attribute[key] || [];
              }
            }

            for (const key in this.defaultParameterOptions) {
              if (
                !this.$validate.isObjectKeyValid(
                  this.selectAttributeOptions[element.id],
                  key
                )
              ) {
                this.selectAttributeOptions[element.id][key] = [];
              }
            }
          });
        }

        // await this.$refs.sideBar.onFilterUser();
      } else if (result.response.status === 404) {
        console.log("error", result.response.data.message);
      } else {
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    onConfirmDelete(userId) {
      this.deleteUserId = userId;
      this.textConfirmDeleteModal = "คุณต้องการลบ <b>" + name + "</b> หรือไม่ ?";
      this.confirmDeleteModal = true;
    },
    async onDelete() {
      this.textConfirmDeleteModal = "";
      this.confirmDeleteModal = false;
      let result = await groupService.deleteGroupUserByUserIdAsync(
        this.GET_APPLICATION_SELECTED.id,
        this.group.id,
        this.deleteUserId
      );
      if (result.status === 200) {
        this.textConfirmDeleteModal = "";
        this.confirmDeleteModal = false;

        this.$utils.notification("success", "ลบข้อมูลสำเร็จ", 1500);
        await this.getGroupUsersSelected(this.group.id);
      } else {
        this.textConfirmDeleteModal = "";
        this.confirmDeleteModal = false;
        this.id = 0;
        eventBus.$emit("error-modal", result.response.data.message);
      }
    },
    onDropdownShown(userOpenId) {
      this.selectAttributesOptions = [];
      const userOptions = this.selectAttributeOptions[userOpenId];
      if (this.$validate.isObjectValid(userOptions)) {
        for (const key in userOptions) {
          const objs = userOptions[key];
          if (this.$validate.anyArrayObjectValid(objs)) {
            const mapObjs = objs.map((item) => ({ key, value: item }));
            this.selectAttributesOptions.push(...mapObjs);
          }
        }
        this.isDefaultParameterOptions = this.$validate.anyArrayObjectValid(
          this.selectAttributesOptions
        );
      }
    },
    async onApplyAttributes(userId) {
      const items = this.selectAttributesOptions;
      const groupUser = this.groupUsers.filter((q) => q.id === userId);
      const applyAttributes = {};
      for (const item of items) {
        const { key, value } = item;
        // if (!this.$validate.anyArrayObjectValid(value)) continue;
        if (this.$validate.isObjectKeyValid(applyAttributes, key)) {
          applyAttributes[key].push(value);
        } else {
          applyAttributes[key] = [value];
        }
      }

      
      await this.onApplyAddUser(groupUser, applyAttributes, userId);
    },
    async onApplyAddUser(groupUser, applyAttributes, userId) {
      if (!this.$validate.anyArrayObjectValid(groupUser)) return;
      const update = {
        users: groupUser,
        attribute: applyAttributes,
      };
      try {
        const result = await groupService.updateGroupAsync(
          this.GET_APPLICATION_SELECTED.id,
          this.group.id,
          update
        );
        if (result.status === 204) {
          this.onModalAttributeHide();
          this.$bvToast.toast("Attributes updated", {
            title: "Success",
            variant: "success",
            solid: true,
            toaster: "b-toaster-bottom-right",
          });
          await this.getGroupUsersSelected(this.group.id);
        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        } else if (result.response.status === 412) {
          console.log(
            "error",
            result.response.data,
            this.$validate.containsKey(result.response.data, "users"),
            this.$validate.anyArrayObjectValid(result.response.data.users.errors)
          );
          if (
            this.$validate.containsKey(result.response.data, "users") &&
            this.$validate.anyArrayObjectValid(result.response.data.users.errors)
          ) {
            this.$utils.notification(
              "error",
              result.response.data.users.errors[0].errorMessage,
              3000
            );
          }
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    onNewAttributeOption() {
      const newAttributeKeyOption = this.newAttributeKeyOption.trim();
      const newAttributeValueOption = this.newAttributeValueOption.trim();
      if (
        this.$validate.isValid(newAttributeKeyOption) &&
        this.$validate.isValid(newAttributeValueOption)
      ) {
        if (
          this.$validate.isObjectKeyValid(
            this.defaultParameterOptions,
            newAttributeKeyOption
          )
        ) {
          this.defaultParameterOptions[newAttributeKeyOption].push(
            newAttributeValueOption
          );
        } else {
          this.defaultParameterOptions[newAttributeKeyOption] = [newAttributeValueOption];
        }
      }
      this.newAttributeKeyOption = "";
      this.newAttributeValueOption = "";
      this.isDefaultParameterOptions = this.$validate.isObjectValid(
        this.defaultParameterOptions
      );
    },
    async onDefaultAttributes() {
      try {
        const result = await serviceService.getApplicationServiceParameterOptionsAsync(
          this.GET_APPLICATION_SELECTED.id
        );
        if (result.status === 200) {
          const data = result.data;
          if (this.$validate.isObjectValid(data)) {
            this.defaultParameterOptions = data;
            this.tempDefaultParameterOptions = { ...data };
          }
        } else if (result.response.status === 404) {
          console.log("error", result.response.data.message);
        } else {
          eventBus.$emit("error-modal", result.response.data.message);
        }
      } catch (error) {
        console.log("error", error);
      }
    },
    onDefaultParameterOptions(userOpenId) {
      
      let selectAttributeOptions = this.selectAttributeOptions;
      if (
        !this.$validate.isObjectValid(selectAttributeOptions) ||
        !this.$validate.isObjectKeyValid(selectAttributeOptions, userOpenId) ||
        !this.$validate.isObjectValid(selectAttributeOptions[userOpenId])
      ) {
        return this.defaultParameterOptions;
      }

      let item = selectAttributeOptions[userOpenId];
      let defaultParameterOptions = { ...this.defaultParameterOptions };

      const filterItems = Object.keys(item).filter((itemKey) => {
        const itemValue = item[itemKey];
        return !Object.keys(defaultParameterOptions).some((optionKey) => {
          const optionValue = defaultParameterOptions[optionKey];
          return optionKey === itemKey && optionValue.includes(itemValue);
        });
      });

      if (this.$validate.anyArrayObjectValid(filterItems)) {
        filterItems.forEach((key) => {
          let _temp = new Set(item[key]);
          if (Object.keys(defaultParameterOptions).some((q) => q === key)) {
            defaultParameterOptions[key].forEach((element) => {
              _temp.add(element);
            });
          }
          defaultParameterOptions[key] = Array.from(_temp);
        });
      }

      
      return defaultParameterOptions;
    },
    onModalAttributeHide() {
      this.showAttributeModal = false;
      this.defaultParameterOptions = { ...this.tempDefaultParameterOptions };
    },
  },
};
</script>

<style scoped>
.switches-channel {
  margin-top: 13px;
}
.mdi.mdi-plus-circle-outline.font-size-18 {
  color: #556ee6;
}
.margin-center-auto {
  margin: auto;
}
.text-clear-all {
  color: #7475d2;
  cursor: pointer;
}
.dropdown-header {
  padding: 4px 5px 0 5px;
}
.b-dropdown-form {
  padding: 4px 15px 0 15px;
}
.list-unstyled {
  margin-left: 0;
}
.text-sm {
  font-size: 0.7rem;
}
.text-link {
  color: #7475d2;
  cursor: pointer;
}
.width-attr-right-rem {
  width: 25rem;
}
.dropdown-menu {
  min-width: 1rem !important;
}
.mr-03rem {
  margin-right: 0.3rem;
}
.card-body {
  padding: 0.5rem;
}
.bd-sl-1 {
  border-right: 1px solid #eee;
}
.dropdown-menu {
  width: 32rem !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
style
